import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import { BaseEditComponent } from "../../core/common/base-component";
import { FormUtil } from "../../core/form.util";
import { AbTestsService } from "../services/ab-tests.service";
import { AbTest } from "../ab-tests.interfaces";
import { Title } from '@angular/platform-browser';
const alertify = require("alertify.js");

@Component({
  selector: "ch-ab-tests-edit",
  templateUrl: "./ab-tests-edit.component.html",
  styleUrls: ["./ab-tests-edit.component.css"],
})
export class AbTestsEditComponent extends BaseEditComponent implements OnInit, OnDestroy {
  public breadcrumbs = ["AbTests"];
  public paramId: string;
  public abTest: AbTest = {
    id: null,
    createdAt: null,
    updatedAt: null,
    name: null,
    description: null,
    split: 50,
    isActive: false,
    useUnauthId: false,
    imageAId: null,
    imageBId: null,
  };
  public errors: any = {};

  constructor(private router: Router, private service: AbTestsService, private route: ActivatedRoute, private titleService: Title) {
    super();
    alertify.logPosition("bottom right");
    this.route.queryParams.subscribe(params => {
      this.paramId = params['id'];
    });
  }

  ngOnInit() {
    if (this.paramId) {
      this.breadcrumbs.push('Edit');
      this.loadAbTest();
    } else {
      this.titleService.setTitle(`New AB Test | CODE Hospitality CMS`);
      this.breadcrumbs.push('Add');
    }
  }

  ngOnDestroy() {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadAbTest() {
    this.loading = true;
    const id = this.paramId;
    this.service.getAbTestById(id).subscribe(
      (res) => {
        this.abTest = res.json();
        this.titleService.setTitle(`${this.abTest.name} | AB Tests | CODE Hospitality CMS`);
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.alertError(err);
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }

  public imageAChanged(resourceId: string) {
    this.abTest.imageAId = resourceId;
  }

  public imageBChanged(resourceId: string) {
    this.abTest.imageBId = resourceId;
  }

  public save(form: NgForm) {
    if (!FormUtil.isValid(form)) {
      return;
    }

    this.loading = true;
    if (this.abTest.id) {
      this.service.updateAbTest(this.abTest.id, this.abTest).subscribe(
        (res) => {
          this.loading = false;
          this.loadAbTest();
        },
        (err) => {
          this.loading = false;
          this.alertError(err);
        }
      );
    } else {
      this.service.createAbTest(this.abTest).subscribe(
        (res) => {
          this.loading = false;
          this.router.navigate(['/admin/ab-tests/edit'], { queryParams: { id: res.json() } });
        },
        (err) => {
          this.loading = false;
          this.alertError(err);
        }
      );
    }
  }

  public delete() {
    if (this.abTest.id === null) {
      return;
    }

    this.loading = true;
    this.service.deleteAbTest(this.abTest.id).subscribe(
      (res) => {
        alertify.success("AB test deleted successfully");
        this.router.navigateByUrl("/admin/ab-tests");
      },
      (err) => {
        this.alertError(err);
        this.loading = false;
      }
    );
  }

  public cancel() {
    this.router.navigateByUrl("/admin/ab-tests");
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/ab-tests/ab-tests-edit/ab-tests-edit.component.ts